import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import SideNavItem from 'components/atoms/SideNavItem';
import Alert from 'components/atoms/Alert';
import { getValues } from 'services/storage';
// import { selectNavItem, storeCurrentPath } from 'redux/app/app.action';
import { ToTitleCase } from 'components/atoms/CaseManager';
import downArrow from '../../assets/svg/arrow-down-light.svg';
import logoutIcon_w from '../../assets/svg/logout-white.svg';
import { logoutFunc } from 'utils';
import homeIconSolid from '../../assets/svg/hubSolid.svg';
import homeIconOutline from '../../assets/svg/hubOutline.svg';
import receiptIconSolid from '../../assets/svg/receipt-text_solid.svg';
import receiptIconOutline from '../../assets/svg/receipt-text_outline.svg';
import settingsSolid from '../../assets/svg/setting-solid.svg';
import settingsOutline from '../../assets/svg/setting-outline.svg';
import businessSolid from '../../assets/svg/home-trend-up-solid.svg';
import businessOutline from '../../assets/svg/home-trend-up.svg';
import SeerbitLogo from '../../assets/images/SeerbitLogoTyped.png';
import useWindowSize from '../atoms/WindowWidth';
import SeerbitWhite from '../../assets/svg/SeerbitWhite.svg';
// import Settings from 'pages/dashboard/Settings'

type Props = {
	setModalId?: (id: string) => void;
	setShowModal?: (value: any) => void;
	selectedNavItem: any;
	selectNavItem: (value: any) => void;
	currentPath: any;
	storeCurrentPath: (value: any) => void;
};

const SideNav = (props) => {
	const [showDropdown, setShowDropdown] = useState(false);
	const [selected, setSelected] = useState('home');

	const { windowWidth, windowHeight } = useWindowSize();

	const fname = props.userData.first_name;
	const lname = props.userData.last_name;
	const username = fname + ' ' + lname;

	const navItems = [
		{
			text: 'Home',
			icon1: homeIconSolid,
			icon2: homeIconOutline,
			style: ` block py-4`,
			available: true,
			status: '',
		},

		{
			text: 'Transactions',
			icon1: receiptIconSolid,
			icon2: receiptIconOutline,
			style: ` block py-4`,
			available: true,
			status: '',
		},

		{
			text: 'Businesses',
			icon1: businessSolid,
			icon2: businessOutline,
			style: `block py-4`,
			available: true,
			status: '',
		},
		{
			text: 'Settings',
			icon1: settingsSolid,
			icon2: settingsOutline,
			style: `block py-4`,
			available: true,
			status: '',
		},
	];

	useEffect(() => {
		const path = window.location.pathname.split('/')[2];
		switch (path) {
			case 'transactions':
				return setSelected('transactions');
			case 'businesses':
				return setSelected('businesses');
			case 'settings':
				return setSelected('settings');
			default:
				return setSelected('home');
		}
	}, []);

	const handleNavItemClick = (e, item) => {
		if (!item.available) {
			return;
		}
		setSelected(e.target.dataset.name);
		props.setModalId && props.setModalId(e.target.id);
		props.setShowModal && props.setShowModal(false);
	};

	return (
		<div className="flex flex-col flex-shrink-0 overflow-y-scroll justify-between bg-black sticky min-h-screen h-fit top-0">
			<div className="bottom-0 flex justify-center py-5 text-white">
				<img
					src={SeerbitWhite}
					alt="SeerbitLogo"
					className="w-[180px] h-auto"
				/>
			</div>

			<div className="w-full flex justify-center bg-black">
				<div
					className={`w-full flex flex-col gap-5 my-auto absolute top-24 bg-black`}
				>
					{navItems.map((item, index) => (
						<SideNavItem
							key={index}
							icon1={item.icon1}
							icon2={item.icon2}
							text={item.text}
							style={item.style}
							available={item.available}
							active={
								item.text.toLocaleLowerCase().replace(' ', '_') === selected
							}
							url={`/dashboard/${item.text
								.replace(' ', '_')
								.toLocaleLowerCase()}`}
							onClick={(e) => handleNavItemClick(e, item)}
						/>
					))}
				</div>
			</div>

			<div
				className={`${
					windowHeight <= 750 && 'hidden'
				} bottom-0 border-t border-GrayCustom3 p-5 pb-5`}
			>
				<div className="flex items-center gap-2 custom_container bg-GrayCustom4 rounded-md flex-shrink-0 overflow-auto py-2 px-3">
					<div className="flex items-center gap-2 w-full overflow-hidden">
						<span className="flex justify-center items-center flex-shrink-0 bg-DarkBg3 rounded-full w-8 h-8 border border-Background font-bold text-[10px] leading-4 text-center text-SecondaryAccent4 p-2">
							{username
								.split(' ')
								.map((word) => word.slice(0, 1))
								.join()
								.replaceAll(',', '')
								.toUpperCase()}
						</span>
						<span className="overflow-x-scroll overflow-hidden truncate">
							<p className="font-normal text-xs leading-5 text-SecondaryAccent5">
								{props.userData.partnerBusinessName}
							</p>
							<p className="font-normal text-xs leading-5 text-Black3 truncate">
								{props.userData.partnerEmail}
							</p>
						</span>
					</div>
					{/* <span className='text-Black3 flex-shrink-0'>
            <img src={downArrow} alt="downArrow" className='w-4 h-4' />
          </span> */}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => ({
	userData: state.auth?.user_authData,
	selectedNavItem: state.app.selectedNavItem,
	currentPath: state.app.currentPath,
});

// const mapDispatchToProps = (dispatch: any) => ({
//   selectNavItem: (data: any) => dispatch(selectNavItem(data)),
//   storeCurrentPath: (data: any) => dispatch(storeCurrentPath(data)),
// });

export default connect(mapStateToProps, null)(SideNav);
